import { HighlightedRate } from '@/share/HighlightedRate/HighlightedRate';
import { Spinner } from '@/share/Spinner/Spinner';
import { selectRfs, getFormattedAmericanForwardRate } from '@/store/state/rfs/rfs.selectors';
import { selectCurrentLocale } from '@/store/state/ui/ui.selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

const AmericanForwardRate = () => {
  const locale = useSelector(selectCurrentLocale);
  const rfs = useSelector(selectRfs);
  const waitingForPrice = rfs.status === 'requesting';
  const rate = getFormattedAmericanForwardRate(locale)(rfs);

  return (
    <div className="form-group col-6 p-md-0 ">
      <label className="text-secondary text-large mb-2">
        <FormattedMessage id="trader.spotRate.americanForwardRate" />
      </label>
      <div className="display-4 tabular-figures fw-normal" data-e2e="spot-rate">
        {waitingForPrice ? <Spinner /> : rate !== undefined && <HighlightedRate value={rate} size={3} />}
      </div>
    </div>
  );
};

export default AmericanForwardRate;
